import {
  FEATURE_DEFAULTS,
  FeatureVisibility,
  IFeature,
} from '@principle-theorem/feature-flags';
import { ServiceCodeType } from '@principle-theorem/principle-core/interfaces';
import { Region } from '@principle-theorem/shared';
import { PracticePermissions } from './practices';

export const MOH_FUNDING_REQUESTS_FEATURE: IFeature = {
  ...FEATURE_DEFAULTS,
  label: 'claims-moh',
  visibility: FeatureVisibility.Stable,
  regions: [Region.NewZealand],
  permissions: [
    {
      value: PracticePermissions.FundingRequestsManage,
      description: 'User can manage and approve Funding Requests',
    },
  ],
};

export const ACC_FUNDING_REQUESTS_FEATURE: IFeature = {
  ...FEATURE_DEFAULTS,
  label: 'claims-acc',
  visibility: FeatureVisibility.Stable,
  regions: [Region.NewZealand],
  permissions: [
    {
      value: PracticePermissions.FundingRequestsManage,
      description: 'User can manage and approve Funding Requests',
    },
  ],
};

export const PHYSIOTHERAPY_SERVICE_PROVIDER_FEATURE_LABEL =
  'physiotherapy-service-provider';

export const ADF_SERVICE_PROVIDER_FEATURE_LABEL = 'adf-service-provider';

export const PHYSIOTHERAPY_SERVICE_PROVIDER_FEATURE: IFeature = {
  ...FEATURE_DEFAULTS,
  label: PHYSIOTHERAPY_SERVICE_PROVIDER_FEATURE_LABEL,
  visibility: FeatureVisibility.OptIn,
  regions: [Region.Australia],
  permissions: [],
};

export const ADF_SERVICE_PROVIDER_FEATURE: IFeature = {
  ...FEATURE_DEFAULTS,
  label: ADF_SERVICE_PROVIDER_FEATURE_LABEL,
  visibility: FeatureVisibility.OptIn,
  regions: [Region.Australia],
  permissions: [],
};

export const SERVICE_PROVIDER_FEATURE_MAP: Partial<
  Record<ServiceCodeType, string>
> = {
  [ServiceCodeType.Physiotherapy]: PHYSIOTHERAPY_SERVICE_PROVIDER_FEATURE_LABEL,
  [ServiceCodeType.ADF]: ADF_SERVICE_PROVIDER_FEATURE_LABEL,
};

export const FUNDING_REQUESTS_FEATURE: IFeature = {
  ...FEATURE_DEFAULTS,
  label: 'funding requests',
  visibility: FeatureVisibility.Stable,
  regions: [Region.NewZealand],
  features: [MOH_FUNDING_REQUESTS_FEATURE, ACC_FUNDING_REQUESTS_FEATURE],
  permissions: [
    {
      value: PracticePermissions.FundingRequestsManage,
      description: 'User can manage and approve Funding Requests',
    },
  ],
};
